module.exports = __webpack_public_path__ + "img/logo.c564174b.png";